<template>
  <div class="relative px-4">
    <nuxt-img
        :src="imageSrc"
        :alt="imageAlt"
        class="mx-auto rounded-xl opacity-1"
        width="992"
        height="558"
        format="webp"
        sizes="sm:400px md:100vw lg:100vw xl:1024px"
        loading="lazy"
        :class="showVideo ? 'opacity-0 duration-150 absolute top-0 left-0 right-0 bottom-0 left-6/12 m-0' : ''"
    ></nuxt-img>
    <button
        id="play-button-hero" @click="playVid()" v-if="!showVideo" aria-label="Start video"
        class="flex absolute inset-0 flex-col justify-center w-full h-full text-base text-white bg-opacity-75"
    >
      <svg
          class="m-auto w-32 sm-max:w-12"
          viewBox="-13 -7 205 151"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
      >
        <g filter="url(#filter0_d_13_831)">
          <rect x="31" y="8" width="120" height="120" rx="60" fill="#FAF7F5"/>
          <path
              d="M106.466 65.4079C108.376 66.6081 108.376 69.3919 106.466 70.5921L84.0571 84.6715C82.0185 85.9524 79.3673 84.4871 79.3673 82.0795L79.3673 53.9205C79.3673 51.5129 82.0185 50.0476 84.0571 51.3284L106.466 65.4079Z"
              fill="#f87832"/>
        </g>
        <defs>
          <filter id="filter0_d_13_831" x="0.387754" y="0.653061" width="181.224" height="181.224"
                  filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
            <feFlood flood-opacity="0" result="BackgroundImageFix"/>
            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                           result="hardAlpha"/>
            <feOffset dy="23.2653"/>
            <feGaussianBlur stdDeviation="15.3061"/>
            <feComposite in2="hardAlpha" operator="out"/>
            <feColorMatrix type="matrix" values="0 0 0 0 0.211765 0 0 0 0 0.2 0 0 0 0 0.14902 0 0 0 0.3 0"/>
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_13_831"/>
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_13_831" result="shape"/>
          </filter>
        </defs>
      </svg>

    </button>

    <div class="m-auto max-w-5xl">
      <div id="video-container" class="relative overflow-hidden h-[0px] pb-[56.25%]" v-if="showVideo">
        <iframe
            v-if="videoPLay"
            id="myVideo"
            :src="videoIframeSrc"
            class="absolute top-0 left-0 w-full h-full rounded-3xl"
            allow="autoplay; fullscreen"
            allowfullscreen>
        </iframe>
      </div>
    </div>

  </div>
</template>

<script setup>
const showVideo = ref(false);
const videoPLay = ref(false);

const playVid = () => {
  videoPLay.value = true;
  showVideo.value = true;
};

defineProps({
  imageSrc: {
    type: String,
    default: '/assets/images/video-bg.png'
  },
  imageAlt: {
    type: String,
    default: 'image video'
  },
  videoIframeSrc: {
    type: String,
    default: 'https://player.vimeo.com/video/439100268?autoplay=1#t=0s'
  }
});

defineBuilderComponent({
    friendlyName: 'Video With Button',
    inputs: [
        {
            name: "imageSrc",
            type: "file",
            allowedFileTypes: [
                "jpeg",
                "jpg",
                "png",
                "svg"
            ],
            defaultValue: "/assets/images/video-bg.png"
        },
        {
            name: "imageAlt",
            type: "text",
            defaultValue: "image video"
        },
        {
            name: "videoIframeSrc",
            type: "text",
            defaultValue: "https://player.vimeo.com/video/439100268?autoplay=1#t=0s"
        }
    ]
});
</script>